<template>
  <div>
    <div v-if="currentNas != null" id="show-nas">
      <v-row>
        <v-col cols="6">
          <v-card class="mt-5">
            <v-card-title class="pt-3 pb-2">
              <switch-confirm
                :value.sync="currentNas.isActive"
                :color="currentNas.isActive ? 'green' : 'red'"
                v-on:confirm="updateNasActive()"
                :loading="isLoading"
                :disabled="!isGrantedUser()"
                class="status-switch"
                dense
                no-margin
                :label="currentNas.isActive ? 'Actif' : 'Inactif'"
              >
                <template #confirm-text>
                  Êtes-vous sûr.e de vouloir
                  {{ !currentNas.isActive ? "désactiver" : "activer" }}
                  ce NAS ?
                </template>
              </switch-confirm>
              <v-spacer></v-spacer>
              <v-chip small v-if="currentNas.silence" color="orange">
                Bulle de silence
              </v-chip>
              <v-spacer></v-spacer>
              <v-btn
                v-if="isGrantedUser()"
                color="primary"
                @click.stop="editNasDialog = true"
                icon
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" class="py-0" v-if="currentNas.client != null">
                  <v-list two-line class="pt-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-btn text class="px-0 no-transform">
                            <router-link
                              :to="{
                                name: 'portail-details',
                                params: { id: currentNas.portal.id },
                              }"
                              >{{ currentNas.portal.description }}
                            </router-link>
                          </v-btn>
                        </v-list-item-title>
                        <v-list-item-subtitle
                          >Portail associé</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ currentNas.nasIdentifier }}
                        </v-list-item-title>
                        <v-list-item-subtitle>NAS ID</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ currentNas.password }}
                        </v-list-item-title>
                        <v-list-item-subtitle
                          >Mot de passe</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title v-if="currentNas.nasType != null">
                          {{ currentNas.nasType.description }}
                        </v-list-item-title>
                        <v-list-item-subtitle
                          >Type de contrôleur</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ currentNas.description }}
                        </v-list-item-title>
                        <v-list-item-subtitle>Description</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
              <v-divider class="my-3"></v-divider>
              <v-row>
                <v-col cols="12" md="6" class="py-0">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ getInternationalDate(currentNas.createdAt) }}
                        </v-list-item-title>
                        <v-list-item-subtitle>Créé le</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ currentNas.createdBy }}
                        </v-list-item-title>
                        <v-list-item-subtitle>Créé par</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ getInternationalDate(currentNas.updatedAt) }}
                        </v-list-item-title>
                        <v-list-item-subtitle
                          >Mis à jour le</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ currentNas.updatedBy }}
                        </v-list-item-title>
                        <v-list-item-subtitle
                          >Mis à jour par</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card class="mt-5">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" class="py-1">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          currentNas.monitoringType.description
                        }}</v-list-item-title>
                        <v-list-item-subtitle>Monitoring</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="py-1">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          currentNas.monitoringIp
                        }}</v-list-item-title>
                        <v-list-item-subtitle
                          >Monitoring IP</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="py-1">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          currentNas.privateIp
                        }}</v-list-item-title>
                        <v-list-item-subtitle>VPN IP</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="py-1">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          getInternationalDate(currentNas.lastTunnelAt)
                        }}</v-list-item-title>
                        <v-list-item-subtitle
                          >Dernière VPN Auth</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
              <v-divider class="my-3"></v-divider>
              <v-row>
                <v-col cols="12" md="6" class="py-1">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          currentNas.publicIp
                        }}</v-list-item-title>
                        <v-list-item-subtitle>Public IP</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="py-1">
                  <v-list two-line>
                    <v-list-item :class="handleClass">
                      <v-list-item-content>
                        <v-list-item-title>{{
                          getInternationalDate(currentNas.lastRequestAt)
                        }}</v-list-item-title>
                        <v-list-item-subtitle
                          >Dernière Auth</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="py-1">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          currentNas.totalRequestsNum
                        }}</v-list-item-title>
                        <v-list-item-subtitle
                          >Requêtes totales</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="py-1">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          getInternationalDate(currentNas.lastAuthAt)
                        }}</v-list-item-title>
                        <v-list-item-subtitle
                          >Dernière Auth OK</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="py-1">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          currentNas.totalDelayNum
                        }}</v-list-item-title>
                        <v-list-item-subtitle>
                          Nb requêtes RADIUS délayées
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="py-1">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          getInternationalDate(currentNas.lastDelayAt)
                        }}</v-list-item-title>
                        <v-list-item-subtitle>
                          Dernière requête RADIUS délayée
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <nas-attribute-radius :nas="currentNas"></nas-attribute-radius>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <LoadingDialog />
    </div>
    <edit-nas-dialog
      :open.sync="editNasDialog"
      v-if="editNasDialog"
      :nas="currentNas"
    ></edit-nas-dialog>
  </div>
</template>
<script>
import { onBeforeMount, toRefs, computed } from "@vue/composition-api";
import router from "../router";
import { useNas } from "../composables/nas";
import NasAttributeRadius from "@/components/Nas/NasAttributeRadius";
import { useTitle } from "@/composables/title";
import { date } from "@/composables/date";
import LoadingDialog from "@/components/General/LoadingDialog.vue";
import EditNasDialog from "@/components/Nas/EditNasDialog.vue";
import { useRoles } from "../composables/roles";
import SwitchConfirm from "@/components/General/SwitchConfirm.vue";
import { DateTime } from "luxon";

export default {
  components: {
    NasAttributeRadius,
    LoadingDialog,
    EditNasDialog,
    SwitchConfirm,
  },
  setup() {
    /* Import des API */
    const { setTitle, setIcon } = useTitle();
    const { currentNas, showNas, nasData, updateNas } = useNas();
    const { getInternationalDate } = date();
    const { isGrantedUser } = useRoles();

    /* Variables */
    const nasId = router.currentRoute.params.id;

    /* Computed */
    const handleClass = computed(function () {
      let result = "";
      if (currentNas.active == 0) {
        result = "notActiveRow";
      } else {
        let durationFromNow = null;
        if (currentNas.lastAuthAt != null) {
          const lastAuthAt = DateTime.fromISO(String(currentNas.lastAuthAt));
          const nowDate = DateTime.now();
          const diff = nowDate.diff(lastAuthAt, ["hours"]);
          durationFromNow = diff.toObject().hours;

          console.log(durationFromNow);
        }

        if (durationFromNow > 1 && durationFromNow < 24) {
          result = "warningRow";
        } else if (durationFromNow >= 24 && durationFromNow < 24 * 3) {
          result = "orangeRow";
        } else if (durationFromNow >= 24 * 3 || durationFromNow == null) {
          result = "dangerRow";
        }
      }
      return result;
    });

    /* Méthodes */
    const updateNasActive = async function () {
      const formData = {
        active: currentNas.value.isActive,
        description: currentNas.value.description,
        monitoringIp: currentNas.value.monitoringIp,
        monitoringType: currentNas.value.monitoringType.id,
        nasType: currentNas.value.nasType.id,
        password: currentNas.value.password,
      };
      Object.assign(nasData.nasForm, formData);
      await updateNas(currentNas.value);
    };

    /* Cycle de vie */
    onBeforeMount(async () => {
      await showNas(nasId);
      setTitle(currentNas.value.nasIdentifier);
      setIcon("nas");
    });

    return {
      currentNas,
      getInternationalDate,
      ...toRefs(nasData),
      isGrantedUser,
      updateNasActive,
      handleClass,
    };
  },
};
</script>
<style scoped>
.warningRow {
  background-color: #feea392b;
}
.orangeRow {
  background-color: #ff980042;
}
.dangerRow {
  background-color: #f4433626;
}
.notActiveRow {
  background-color: #9e9e9e;
}
</style>
